export const IS_DATA_SOURCES_FETCHING = "DATA_SOURCES:IS_FETCHING";
export const RECEIVE_DATA_SOURCES = "DATA_SOURCES:RECEIVE_DATA_SOURCES";
export const RECEIVE_DATA_SOURCE = "DATA_SOURCES:RECEIVE_DATA_SOURCE";

export const IS_DATA_SOURCES_STATE_FETCHING =
  "DATA_SOURCES:IS_DATA_SOURCES_STATE_FETCHING";
export const RECEIVE_DATA_SOURCES_STATE =
  "DATA_SOURCES:RECEIVE_DATA_SOURCES_STATE";
export const UPDATE_DATA_SOURCE_STATE = "DATA_SOURCES:UPDATE_DATA_SOURCE_STATE";
export const IS_FETCHING_DATA_SOURCE_STATE =
  "DATA_SOURCES:IS_FETCHING_DATA_SOURCE_STATE";
